<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="h2"><a id="preface04">USDA Plant Hardiness Zone Map</a></p><a id="preface04">
</a><div style="height: 450px"><a id="preface04">
</a><p class="imagen"><a id="preface04"></a><a id="page_xxviii"><img alt="Image" height="100%" src="images/fxxviii-01a.jpg"/></a><a id="page_xxix"></a></p><a id="page_xxix">
</a></div><a id="page_xxix">
</a></div><a id="page_xxix">
<div style="height: 550px">
<p class="imagen"><img alt="Image" height="100%" src="images/fxxviii-01b.jpg"/></p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface04.vue?6cb3840a